.discord-replied-message.discord-executed-command .discord-command-name {
	color: #00aff4;
	font-weight: 500;
}

.discord-replied-message.discord-executed-command .discord-command-name:hover {
	color: #00aff4;
	text-decoration: underline;
}

.discord-replied-message.discord-executed-command .discord-replied-message-username {
	margin-right: 0;
}

@import '../discord-reply/discord-reply.css';
